import { FormGroup } from "@material-ui/core";
import { Fragment, useState, useEffect } from "react";
import { Col, Input, Label } from "reactstrap";
import WaitingIcon from '../../../assets/WaitingIcon';
import ButtonCommon from "../../../components/ButtonCommon";
import CustomAlerts from "../../../components/AlertCustom.js";
import InputCommon from "../../../components/InputCommon";
import CommonModal from "../../../components/CommonModal";
import IsEligible from './IsEligible';
import ErrorSection from './ErrorSection';
import Profile from './Profile';
import BureauVerification from './BureauVerification';
import './../index.scss'
import CircularProgress from '@material-ui/core/CircularProgress';
import { getCaptcha, getActiveGstinDetail, setConsent, getBussinessDetail, getGstinDetail, getUserDetail } from '../../../api/onboarding';
import NotEligible from "./NotEligible";

const CheckEligibiltyForm = (props) => {

  const [ form , setForm ] = useState({pan: '', captcha: '', downloadConsent: false, bureauConsent: false, entityAuthorizedConsent: false, formValid: false })
  const [captchaData, setCaptchaData] = useState({});
  const [step, setStep] = useState('loadingState');
  const [gstDetail, setGstDetail] = useState({});
  const [generatingOffer, setGeneratingOffer] = useState(false);
  const [bureauData, setBureauData] = useState({});
  const [userData, setUserData] = useState({})
  const [loading, setLoading] = useState(false);

  const fetchGstinDetail = () => {
    getGstinDetail().then(res => {
      setGstDetail(res);
      setStep('businessDetail');
    }).catch(err => {
      if (props.status.userState === "GST_PRECONDITION_PASSED" || props.status.userState === 'NEW_USER') {
        setStep('profile')
      } else {
        setStep('panDetail');
        fetchCaptcha();
      }
    })
  }

  const onChange = (value, key) => {
    let currentForm = {...form};
    currentForm[key] = value;
    if (currentForm.pan && currentForm.captcha && currentForm.downloadConsent && currentForm.bureauConsent && currentForm.entityAuthorizedConsent) {
      currentForm.formValid = true;
    } else {
      currentForm.formValid = false;
    }
    setForm(currentForm);
  }

  useEffect(() => {
    getUserDetail().then(res => {
      setUserData(res)
    })
    if(props.status) {
      if(props.status.userState === 'NOT_ELIGIBLE_FOR_LOAN') {
        setStep('notEligible')
      } else if (props.status.userState === "GST_PRECONDITION_PASSED" || props.status.userState === 'NEW_USER') {
        setStep('profile')
      } else if (props.status.userState === "PROFILE_COMPLETED") {
        setStep('panDetail');
        fetchCaptcha();
      } else {
        fetchGstinDetail();
      }
    }
  },[props.status])

  const fetchCaptcha = () => {
    getCaptcha().then(res => {
      setCaptchaData(res)
    })
  }

  const submitForm = () => {
    if ((form.pan?.split('')[3]).toLowerCase() !== 'p') {
      setStep('ErrorSection')  
      setForm({pan: '', captcha: '', downloadConsent: false, bureauConsent: false, entityAuthorizedConsent: false, formValid: false });
      return
    }
    setLoading(true);
    
    let apiData = {pan: form.pan, captcha: form.captcha, captchaId: captchaData.captchaId}
    getActiveGstinDetail(apiData).then(res => {
      if (res.length) {
        let activeGstin = res.filter(item => item.status === 'Active')
        if (activeGstin.length === 0) {
          setStep('ErrorSectionNoGST');
        } else if (activeGstin.length <= 2) {
          fetchBussinessDetail(activeGstin)
        } else if (activeGstin.length > 2) {
          setStep('ErrorSectionMoreGST');
        }
      }
    }).catch(err => {
      fetchCaptcha();
      let currentForm = {...form};
      currentForm.captcha = '';
      setForm(currentForm);
      setLoading(false);
      CustomAlerts({
        message : err.message,
        title:'Error',
        type:'danger'
      })
    })
  }

  const fetchBussinessDetail = async (gstins) => {
    await setConsent();

    let gstDetail = {pan: form.pan, gstinDetails: gstins}
    await getBussinessDetail(gstDetail).then(res => {
      setStep('businessDetail');
      setGstDetail(res);
    }).catch(err => {
      fetchCaptcha();
      let currentForm = {...form};
      currentForm.captcha = '';
      setForm(currentForm);
      setLoading(false);
      CustomAlerts({
        message : err.message,
        title:'Error',
        type:'danger'
      })
    })
  }

  useEffect(() => {
    setLoading(false);
  },[step])

  const renderErrorMessage = () => {
    if (step === 'ErrorSection') {
      return 'Currently we only support GST PayLater for proprietorship PANs.'
    } else if (step === 'ErrorSectionMoreGST') {
      return 'Currently we only support PANs with maximum 2 GSTINs'
    } else if (step === 'ErrorSectionNoGST') {
      return 'We cannot see any active GSTINs for this PAN'
    } 
  }

  const setPanDetailStep = () => {
    setStep('panDetail');
    fetchCaptcha();
    setForm({pan: '', captcha: '', downloadConsent: false, bureauConsent: false, entityAuthorizedConsent: false, formValid: false });
  }

  const renderPageContent = () => {
    if (step === 'loadingState') {
      return <Fragment>
        <div className="loading">
          <CircularProgress />
        </div>
      </Fragment>
    } else if (step === 'profile') {
      return <Fragment>
        <Profile setStep={() =>  setPanDetailStep() } setUserData={setUserData} />
      </Fragment>
    } else if (step === 'notEligible') {
      return <Fragment>
        <NotEligible />
      </Fragment>
    } else if (step === 'ErrorSection' || step === 'ErrorSectionMoreGST' || step === 'ErrorSectionNoGST') {
      return <ErrorSection goBack={ () => { setPanDetailStep() } } text={renderErrorMessage()}/>
    } else if (step === 'panDetail') {
      return <Fragment>
        <div className="checkEligibiltyForm">
          <Col md={12}>
            <Col md={6}>
              <h3>Enter PAN number associated with your business</h3>
              <InputCommon 
                onChange={(e) => onChange(e.target.value, 'pan')} 
                value={form.pan}
                autoFocus
              />
            </Col>
            <Col md={6}>
              <h3>Enter Captcha</h3>
              <InputCommon  
                onChange={(e) => onChange(e.target.value, 'captcha')} 
                value={form.captcha}
              />
            </Col>
            <div>
              {captchaData.captcha && <img src={'data:image/png;base64,'+captchaData.captcha} />}
            </div>
            <FormGroup check>
              <Label check>
                <Input type="checkbox"  disabled={loading} checked={form.entityAuthorizedConsent} onChange={(e) => onChange(e.target.checked, 'entityAuthorizedConsent')} />{' '}
                I represent that I have due authority to act on behalf of the legal entity opting for Cleartax GST Pay Later. 
              </Label>
              <Label check>
                <Input type="checkbox" disabled={loading} checked={form.downloadConsent} onChange={(e) => onChange(e.target.checked, 'downloadConsent')} />{' '}
                I authorize ClearTax to retrieve entity's data from GSTN and to transmit such data to Rupifi for the purpose of availing a loan or line of credit for making GST related payments.
              </Label>
              <Label check>
                <Input type="checkbox" disabled={loading} checked={form.bureauConsent} onChange={(e) => onChange(e.target.checked, 'bureauConsent')} />{' '}
                I expressly agree to ClearTax GST Pay Later - <a target="_blank" href="https://assets1.cleartax-cdn.com/clearcapital/images/1627453326_cleartaxgstpaylatertermsandconditions.pdf">Terms and Conditions</a> and Rupifi <a target="_blank" href="https://assets1.cleartax-cdn.com/clearcapital/images/1627453353_rupifitermsandconditions.pdf">Terms and conditions</a> and I further agree to appoint Rupifi as the entity's authorized representative to receive credit information from the credit information companies.
              </Label>
            </FormGroup>
            <ButtonCommon disabled={!form.formValid || loading} title={loading ? "Loading..." : "Proceed to download GST Data"} onClick={() => submitForm()} />
          </Col>
        </div>
      </Fragment>
    } else if(step === 'businessDetail') {
      return <IsEligible userData={userData} setSection={props.setSection} setStatus={props.setStatus} setBureauData={setBureauData} setStep={setStep} userState={props.status.userState} gstDetail={gstDetail} {...props} setGeneratingOffer={setGeneratingOffer} />
    } else if (step === 'BUREAU_MISMATCH') {
      return <BureauVerification setStep={setStep} bureauData={bureauData} />
    }
  }

  const renderWaitingModal = () => {
    return <CommonModal open={generatingOffer} maxWidth='md'>
      <div className="waitingModalCon">
        <div className="waitingIcon">
          <WaitingIcon />
        </div>
        <div className="waitingTextCon">
          <h4>Please wait, our lending partner is generating a loan offer for you.</h4>
          <p>Please do not press back button, this might take upto 30 seconds...</p>
        </div>
      </div>
    </CommonModal>
  }

  return (
    <Fragment>
      {renderPageContent()}
      {renderWaitingModal()} 
    </Fragment>
  )
}

export default CheckEligibiltyForm;